import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="max-w-2xl">
      <h1 className="text-2xl font-semibold mb-2">404</h1>
      <p className="text-gray-600 mb-4">Page not found.</p>
      <Link to="/" className="text-blue-600 hover:underline text-sm">
        ← Back to Listings
      </Link>
    </div>
  );
}
